export default __webpack_public_path__ + "media/zurb/img/events/wired/pie-ranch/pr-3-6da05a6deefc09c2708754b4e9acb72b.jpg";